module.exports = __webpack_public_path__ + "img/1530280594.b3873e15.jpg";